import React from 'react';
import { useIntl } from 'react-intl';
import { SelectGroup } from '~/admin/shared/forms/BasicForm';
import { SYSCO_OPCO_OPTIONS } from './syscoOpcoOptions';

// isRequiredTitleLabel interpolates title into a template string (Select.jsx's getTitle()), so
// title must stay a plain string here, not a <FormattedMessage> element — same as every other
// required field in this form.
const SyscoOpcoField = () => {
  const intl = useIntl();

  return (
    <SelectGroup
      field="opco"
      title={intl.formatMessage({ defaultMessage: 'Sysco OpCo' })}
      isClearable={false}
      isSearchable
      isRequiredTitleLabel
      options={SYSCO_OPCO_OPTIONS}
      data-testid="sysco-opco-input"
      data-tour-id="sysco-opco-input"
      menuPortalTarget={document.body}
      menuPosition="fixed"
      menuPlacement="auto"
    />
  );
};

export default SyscoOpcoField;
